import blogPhoto1 from '../images/knife-block-1.png'
import blogPhoto2 from '../images/knife-block-2.png'
import blogPhoto3 from '../images/knife-block-3.png'
import blogPhoto4 from '../images/knife-block-4.png'


export const blogData =[
	{
		title: 'Все про ножі: як правильно вибрати',
		date: '24.07.2022',
		text: [
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
			],
		image: blogPhoto1,
	},
	{
		title: 'Як правильно вибрати ліхтар',
		date: '24.07.2022',
		text: [
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
			],
		image: blogPhoto2,
	},
	{
		title: 'Кухонні ножі для господарок',
		date: '24.07.2022',
		text: [
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
			],
		image: blogPhoto3,
	},
	{
		title: 'Кухонні ножі для господарок',
		date: '24.07.2022',
		text: [
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
				'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aspernatur, quae qui neque iusto iure a nemo odio temporibus quaerat autem expedita nostrum ipsam at exercitationem ab, architecto est sint fuga!',
			],
		image: blogPhoto4,
	},
]